import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import Slider from '@material-ui/core/Slider';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import * as a from '../../../../../actions';
import styles from '../RecommendationSettings.module.scss';

const DEVICE_SETTINGS = [
  { key: 'widget-products-inrow-sm', labelKey: 'recommendations.settings.general.mobile' },
  { key: 'widget-products-inrow-md', labelKey: 'recommendations.settings.general.tablet' },
  { key: 'widget-products-inrow-lg', labelKey: 'recommendations.settings.general.laptop' },
  { key: 'widget-products-inrow-xl', labelKey: 'recommendations.settings.general.desktop' },
];

const General = ({ onDirty }) => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { settings } = useSelector(store => store);
  const recsVisible = settings.recsVisible || { value: false };
  const theme = settings.recs?.theme || {};

  const changeVisibility = (event) => {
    dispatch(a.updateRecsVisible(event.target.checked));
    onDirty();
  };
  const changeProductsPerRow = (key, value) => {
    dispatch(a.changeRecsThemeSetting(key, value));
    onDirty();
  };

  return (
    <div className={styles.sections} data-testid="recommendation-general-settings">
      <section className={styles.card}>
        <div className={styles.cardHeader}>
          <div>
            <h2>{localizeMessage('recommendations.settings.general.integration.title')}</h2>
            <p>{localizeMessage('recommendations.settings.general.integration.hint')}</p>
          </div>
          <span className={`${styles.statusBadge} ${recsVisible.value ? styles.statusEnabled : ''}`}>
            {localizeMessage(recsVisible.value
              ? 'recommendations.settings.general.status.enabled'
              : 'recommendations.settings.general.status.disabled')}
          </span>
        </div>
        <div className={styles.settingRow}>
          <div className={styles.settingText}>
            <h3>{localizeMessage('recommendations.settings.general.enabled.title')}</h3>
            <p>{localizeMessage('recommendations.settings.general.enabled.description')}</p>
          </div>
          <Switch
            color="primary"
            checked={Boolean(recsVisible.value)}
            onChange={changeVisibility}
            inputProps={{
              'aria-label': localizeMessage('recommendations.settings.general.enabled.title'),
            }}
          />
        </div>
      </section>

      <section className={styles.card}>
        <div className={styles.cardHeader}>
          <div>
            <h2>{localizeMessage('recommendations.settings.general.layout.title')}</h2>
            <p>{localizeMessage('recommendations.settings.general.layout.hint')}</p>
          </div>
        </div>
        <div className={styles.deviceGrid}>
          {DEVICE_SETTINGS.map(({ key, labelKey }) => {
            const value = theme[key] ?? 1;
            const label = localizeMessage(labelKey);
            return (
              <div className={styles.deviceCard} key={key}>
                <div className={styles.deviceHeader}>
                  <span className={styles.deviceName}>{label}</span>
                  <strong className={styles.deviceValue}>{value}</strong>
                </div>
                <Slider
                  value={value}
                  onChange={(event, nextValue) => changeProductsPerRow(key, nextValue)}
                  min={1}
                  max={5}
                  step={1}
                  marks
                  valueLabelDisplay="auto"
                  aria-label={localizeMessage(
                    'recommendations.settings.general.layout.ariaLabel',
                    { device: label },
                  )}
                />
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

General.propTypes = {
  onDirty: PropTypes.func,
};

General.defaultProps = {
  onDirty: () => {},
};

export default General;
